import { useState, useEffect } from 'react';

const useIsSpendValid = (value: number) => {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    setIsValid(value >= 0 && value <= 99999);
  }, [value]);

  return isValid;
};

export default useIsSpendValid;
